// extracted by mini-css-extract-plugin
export default {"postsceleton":"PostSceleton_postsceleton__Y20SN","shineForSkeleton-yhx2baozlun":"PostSceleton_shineForSkeleton-yhx2baozlun__PHarq"};